// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"53c57817","238":"53c57817","272":"53c57817","333":"53c57817","334":"53c57817","342":"0e2559ab","471":"53c57817","490":"53c57817","718":"f8382a43","743":"53c57817","764":"53c57817","853":"53c57817","857":"53c57817"}[chunkId] + ".chunk.css";
};